var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"secondary","x-small":"","outlined":"","loading":_vm.loading},on:{"click":_vm.save}},[_vm._v("Set "+_vm._s(_vm.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }